'use client';

import { ElementViewed } from '@repo/segment/Analytics/ElementViewed';
import { FeatureViewed } from '@repo/segment/components/FeatureViewed';

type BankingAssessmentBannerControlTrackerProps = {
  isExperimentActive: boolean;
};

export function BankingAssessmentBannerControlTracker({
  isExperimentActive,
}: BankingAssessmentBannerControlTrackerProps) {
  if (!isExperimentActive) {
    return null;
  }

  return (
    // TODO: Segment Standardization Cleanup
    <FeatureViewed entityName="baf_control_banner" entitySection="banking">
      <div>
        <ElementViewed entityName="baf_control_banner" sectionName="banking">
          <div style={{ height: 0, overflow: 'hidden' }} />
        </ElementViewed>
      </div>
    </FeatureViewed>
  );
}
